import Tippy from '@tippyjs/react';

import Checkbox from 'components/shared/Checkbox/Checkbox';

const AcceptCheckbox = ({ id, label, isChecked, onChange, disabled, tooltip }) => {
  const content = (
    <div className={`flex items-start gap-2 ${disabled ? 'opacity-60' : ''}`}>
      <div className="pt-0.5">
        <Checkbox
          id={id}
          label=""
          isChecked={isChecked}
          onChange={onChange}
          disabled={disabled}
          size={18}
        />
      </div>
      <label htmlFor={id} className="text-sm text-neutral-800">
        {label}
      </label>
    </div>
  );

  if (tooltip) {
    return (
      <Tippy content={tooltip} placement="left" maxWidth={294} className="tippy-dark">
        <div>{content}</div>
      </Tippy>
    );
  }

  return content;
};

export default AcceptCheckbox;
